
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout   from './DashboardLayout';
import DashboardHome     from './components/DashboardHome';
import MerchantFee from './components/MerchantFee';
import DonationPage from './components/DonationPage';
import SubscriptionDetailsPage from './components/SubscriptionDetailsPage';
import TicketPage from './components/TicketPage';
import SubscriptionPage from './components/SubscriptionPage';
import ProgrammeListPage from './components/ProgrammeListPage';
import PublicProfilePage from './components/PublicProfilePage';
import PrayerTimesPage from './components/PrayerTimesPage';
import AdvertisementPage from './components/AdvertisementPage';
import ReportsPage from './components/ReportsPage';

export default function DashboardRoutes() {
  return (
    <DashboardLayout>
      <Routes>
        {/* index = /dashboard */}
        <Route index           element={<DashboardHome />} />
        <Route path="merchant-fee"   element={<MerchantFee />} />
        <Route path="donation"       element={<DonationPage />} />
        <Route path="subscription"       element={<SubscriptionPage />} />
        <Route path="subscription/details/:id"       element={<SubscriptionDetailsPage />} />
        <Route path="ticker"       element={<TicketPage />} />
        <Route path="programs"       element={<ProgrammeListPage pageTitle="Programs" />} />
        <Route path="events"       element={<ProgrammeListPage pageTitle="Events" />} />
        <Route path="services"       element={<ProgrammeListPage pageTitle="Services" />} />
        <Route path="public-profile"       element={<PublicProfilePage pageTitle="Public Profile" />} />
        <Route path="prayer-times"       element={<PrayerTimesPage pageTitle="Prayer Times" />} />
        <Route path="advertisements"       element={<AdvertisementPage pageTitle="Advertisements" />} />
        <Route path="reports"       element={<ReportsPage pageTitle="Reports" />} />
        
        
        {/* <Route path="*"          element={<Navigate to="/admin" replace />} /> */}
      </Routes>
    </DashboardLayout>
  );
}
